import React from 'react';
import {useHistory} from 'react-router-dom';
import scrollIntoView from 'scroll-into-view-if-needed';
import {sendEvarData} from '@ibibo/analytics';

import {HOME_PAGE_URL} from '../../../constants';

import * as S from './JoinUs.styles';

const JoinUs = () => {
  const history = useHistory();

  const toHomePage = () => {
    sendEvarData({
      prop54: "myPartner|signup|personalDetails|JoinUs"
    }, true)

    if (history.location.pathname === HOME_PAGE_URL) {
      scrollIntoView(document.getElementById('onboarding'), {
        block: 'start',
        behavior: 'smooth'
      });
    } else {
      history.push(HOME_PAGE_URL);
    }
  }

  return (
    <S.JoinOuterWrap>
      <S.JoinInnerWrap>
        <S.FooterInnerWrap>
          <S.FooterTextWrapper>
            So what are you waiting for?
          </S.FooterTextWrapper>
          <S.SearchBtnWrap onClick={toHomePage}>
            <S.SearchBtn>JOIN US</S.SearchBtn>
          </S.SearchBtnWrap>
        </S.FooterInnerWrap>
      </S.JoinInnerWrap>
    </S.JoinOuterWrap>
  );
}

export default JoinUs;
